import { createSlice, createAction } from '@reduxjs/toolkit'

import { orderBy } from 'lodash'

import { handleErrorState } from 'store/helpers/handleErrorState'
import { isClearAccount } from 'store/helpers/isClearAccount'
import { isClearAll } from 'store/helpers/isClearAll'
import { isFulfilled } from 'store/helpers/isFulfilled'
import { isRejected } from 'store/helpers/isRejected'

import { CompanyState } from './types'

const clear = createAction('company/clear')

const initialState: Partial<CompanyState> = { loading: false }

const companySlice = createSlice({
  name: 'company',
  initialState,
  reducers: {
    setCompany(state, action) {
      const orderedSessions = orderBy(
        action.payload?.sessions,
        ['startDate'],
        ['desc']
      )
      const latestSession = orderedSessions[0]
      state.company = {
        ...(action.payload ?? {}),
        sessions: orderedSessions,
      }
      state.latestSession = latestSession
      state.version = 'v2' // legacy, ideally will move to not need this anymore
    },
    setSessionCurrentlyViewing(state, action) {
      state.sessionIdCurrentlyViewing = action.payload
    },
  },
  extraReducers: builder => {
    builder
      .addCase(clear, () => initialState)

      .addMatcher(isClearAll(), () => initialState)
      .addMatcher(isClearAccount(), () => initialState)
      .addMatcher(isRejected('company'), handleErrorState)
      .addMatcher(isFulfilled('company'), state => {
        state.error = undefined
        state.loading = false
      })
  },
})

export const { actions: companyActions, reducer: companyReducer } = companySlice
